import type { LibraryState } from "./activity-library";

export type ReferenceCorrection = {
  explanation?: string;
  numericAnswer?: number;
  tolerance?: number;
  unit?: string;
  acceptedAnswers?: string[];
};

const DOPPLER_REFERENCE_ID = "reference-doppler";
const DOPPLER_CORRECTION_REVISION = 5;

export function dopplerCorrectionsNeedUpgrade(state: LibraryState): boolean {
  const activity = state.activities.find((item) => item.id === DOPPLER_REFERENCE_ID);
  if (!activity) return false;
  const version = state.versions.find(
    (item) => item.id === activity.id && item.version === activity.version,
  );
  const questions = version?.package?.interactive.blocks.filter(
    (block) => block.type === "question",
  );
  if (!questions?.length) return false;
  const revision = version?.package?.interactive.revision ?? 0;
  return revision < DOPPLER_CORRECTION_REVISION || questions.some(
    (question) => !question.correction?.explanation?.trim(),
  );
}
